<template>
  <div class="password-reset-page overflow-x-hide">
    <div class="container no-padding">
      <div class="row no-margin">
        <div class="col-md-12" :style="{ 'min-height': dyn_height }">
          <HeaderLogo
            :page-type="`404`"
            :language-picker="true"
            :light_logo="true"
          />
          <div
            class="row no-padding main-body h-100"
            :style="{ height: windowHeight }"
          >
            <div class="col-md-12 flex-container">
              <BrandPattern2 page="LOGIN" />
            </div>
          </div>
        </div>
        <ErrorHandler
          v-if="showProspectCallbackError || null"
          :prospect-callback-error-msg="prospectCallbackErrorMsg"
          :is-positive="isPositiveNotification"
          @reset-show-prospect-callback-error="resetShowProspectCallbackError"
        />

        <!-- Create account Modal -->
        <div
          id="passwordResetModal"
          ref="passwordResetModal"
          class="modal fade password-reset-modal tw-block"
          aria-labelledby="passwordResetModalLabel"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="onClickClose"
                >
                  <img src="@/assets/img/close.svg" />
                </button>
              </div>
              <div class="modal-body">
                <div class="modal-body-sec1">
                  {{ getUiText("app-user-verify-secret-org-title-1") }}
                </div>
                <div class="form-group">
                  <label for="id" class="control-label input-label-form">{{
                    getUiText("app-user-verify-secret-org-content-1")
                  }}</label>
                  <!--
                    <input
                    id="email"
                    ref="email"
                    v-model="secretKey"
                    type="email"
                    class="form-control form-control-lg form-input"
                    tabindex="0"
                    @keydown.enter="submit"
                    />
                  -->
                </div>
                <div class="help-text">
                  {{ getUiText("app-user-verify-secret-org-note-1") }}
                </div>
                <div class="letsgo-btn">
                  <button
                    type="button"
                    class="btn btn-primary letsgo-button"
                    tabindex="3"
                    :disabled="isLoading"
                    @click="submit"
                  >
                    {{
                      getUiText(
                        "app-settings-domain-verify-modal-verify-button-1",
                      )
                    }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import HeaderLogo from "@/components/common/headerLogo.vue";
import BrandPattern2 from "@/components/prospect/brandPattern/brandPattern2.vue";
import ErrorHandler from "@/components/common/exceptionHandler.vue";
import utilities from "@/utils/utilities";
import { successStatusCodes } from "@/utils/constants";
import { onBeforeUnmount, onMounted, ref } from "vue";
import Utils, { getComponentUiText } from "@/utils/utilities";
import { load } from "recaptcha-v3";
import { useRouter, useRoute } from "vue-router";
import store from "@/store";
const router = useRouter();
const route = useRoute();
const token: any = ref("");
if (route.query && route.query.token) {
  token.value = route.query.token;
  router.push({ path: "/org/verify/email/callback" });
} else {
  router.push({ path: "/user/login" });
}

const dyn_height = ref("0");
const windowHeight = ref("");
const showProspectCallbackError = ref(false);
const prospectCallbackErrorMsg = ref("");
const email = ref("");
// const secretKey = ref(null);
const isPositiveNotification = ref(false);
const isLoading = ref(false);
const passwordResetModal = ref<null>(null);
const defaultUiText = ref(store.state.LanguagePicker.defaultUiText);
const languageSelectedText = ref(
  store.state.LanguagePicker.languageSelectedText,
);

const onResize = () => {
  dyn_height.value = `${window.innerHeight}px`;
  windowHeight.value = `${window.innerHeight}px !important`;
  // secretKey.value && secretKey.value.focus();
};

const getUiText = (id, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const resetShowProspectCallbackError = () => {
  showProspectCallbackError.value = false;
  prospectCallbackErrorMsg.value = "";
};

const submit = async () => {
  isLoading.value = true;
  const recaptcha = await getRecaptcha();
  const data = {
    recaptcha: recaptcha,
    token: token.value,
  };
  verifyOrganisation(data);
};
const verifyOrganisation = async (data) => {
  try {
    const res: any = await store.dispatch("Org/handleOrgVerifiCallback", data);
    if (res.status == successStatusCodes.OK) {
      showErrorInfo(
        {
          message: getComponentUiText("app-user-verify-successful-org-1"),
        },
        true,
      );
      setTimeout(() => {
        router.push({ path: "/settings/organisation/access" });
      }, 1000);
    } else {
      return showErrorInfo({
        message:
          res?.data?.error?.message ||
          getComponentUiText("app-user-verify-error-org-1"),
      });
    }
  } catch (error: any) {
    return showErrorInfo({
      message: getComponentUiText("app-user-verify-error-org-1"),
    });
  } finally {
    setTimeout(() => {
      isLoading.value = false;
    }, 1000);
  }
};
const showErrorInfo = (errorInfo, stateIsPositiveNotification = false) => {
  if (errorInfo && errorInfo !== "") {
    isPositiveNotification.value = stateIsPositiveNotification;
    errorInfo =
      typeof errorInfo === "string" ? JSON.parse(errorInfo) : errorInfo;

    if (errorInfo && Object.keys(errorInfo).length > 0 && errorInfo.message) {
      showProspectCallbackError.value = true;
      prospectCallbackErrorMsg.value = errorInfo.message;
    }
  }
};

const getRecaptcha = async () => {
  try {
    const finalKey = await Utils.getV3Recaptcha();
    const recaptcha = await load(`${finalKey}`, {
      autoHideBadge: true,
    });
    const token = await recaptcha.execute("submit");
    return token;
  } catch (error: any) {
    showErrorInfo(error.data);
    router.push({ path: "/" });
  }
};
const onClickClose = () => {
  router.go(-1);
};

const beforeUnmount = () => {
  if (document.body.classList.contains("page-opacity")) {
    document.body.classList.remove("page-opacity", "page-bg", "page-shadow");
  }
};

onMounted(() => {
  onResize();
  window.addEventListener("resize", onResize);
  document.getElementById("passwordResetModal")?.classList.add("show");
  if (!document.body.classList.contains("page-opacity")) {
    onResize();
    document.body.classList.add("page-opacity", "page-bg");
  }
});

onBeforeUnmount(() => {
  beforeUnmount();
  window.removeEventListener("resize", onResize);
});
</script>

<style lang="scss" scoped>
.password-reset-page {
  background: #0345bd;

  .form-control:focus {
    box-shadow: none;
  }
  .form-control::placeholder {
    color: #b7b7b7;
    font-size: 22px;
  }

  .password-reset-modal {
    height: auto;
    width: auto;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .modal-dialog {
      transition: none;
      min-width: 630px;
    }
    .modal-header {
      border: none;
      padding: 10px 10px 0px 10px;
      justify-content: flex-end;
      .close {
        float: right;
        opacity: 1;
        margin-right: 10px;
        margin-top: 10px;
        position: relative;
        padding: 0;
        z-index: 999;

        img {
          width: 19px;
          height: 19px;
        }
      }
    }

    .modal-content {
      box-shadow: 2px 0px 20px rgba(33, 31, 88, 0.1);
      border-radius: 6px;
      border: none;
    }

    .modal-body {
      padding: 35px 195px 48px 50px;

      .flex-container {
        position: absolute;
        bottom: 0px;
        height: 100%;
      }

      .modal-body-sec1 {
        color: #0345bd;
        font-size: 26px;
        font-weight: 600;
        line-height: 39px;
      }

      .letsgo-btn {
        margin-top: 38px;
        display: flex;
        align-items: center;
      }

      .input-label-form {
        font-weight: 500;
        font-size: 12px;
        color: #231f20;
        line-height: 18px;
      }
      .form-input {
        border: none;
        font-style: normal;
        font-weight: 300;
        font-size: 22px;
        line-height: 33px;
        color: #0345bd;
        border-left: 1px solid rgba(183, 183, 183, 0.3);
        border-radius: unset;
      }
      .form-group {
        margin-top: 15px;

        label {
          margin-bottom: 14px;
          margin-top: 14px;
        }
      }

      .password-left-conditions {
        margin-bottom: 0px;
      }

      .letsgo-button {
        width: 208px;
        height: 45px;
        left: 72px;
        border-radius: 29.4638px;
        background: #0345bd;
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        box-shadow: 0px 2px 4px rgba(33, 31, 88, 0.25);
        line-height: 27px;
        text-transform: uppercase;
      }

      .letsgo-button:disabled {
        background: #b7b7b7;
        color: #fff;
        border: none;
        cursor: progress;
      }

      .help-text {
        font-size: 13px;
        line-height: 19px;
        color: #878787;
      }
    }
  }
  .modal {
    z-index: 1 !important;
  }
}
@media (max-width: 767px) {
  .password-reset-page {
    .password-reset-modal {
      .modal-header {
        .close {
          margin-top: 3px !important;
          img {
            width: 17px;
            height: 17px;
          }
        }
      }

      .modal-dialog {
        min-width: unset;
      }
      .modal-body {
        padding: 18px 30px 30px 30px;

        .modal-body-sec1 {
          font-size: 22px;
        }

        .form-group {
          margin-top: 24px !important;
        }
        .letsgo-button {
          width: 136px;
          font-size: 16px;
          line-height: 24px;
        }
        .form-input {
          font-size: 18px;
          padding-right: 0px;
        }
        .form-input::placeholder {
          font-size: 18px;
        }

        .input-label-form {
          font-size: 12px;
          line-height: 18px;
        }

        .letsgo-btn {
          margin-top: 20px;
        }
      }
    }
  }
}

@media (max-height: 500px) {
  .modal {
    padding-top: 50px;
  }
}
@media (min-width: 3840px) {
  .password-reset-page {
    .password-reset-modal {
      .form-control:focus {
        padding-left: 30px;
        font-size: 38px;
        line-height: 30px;
      }
      .modal-dialog {
        max-width: 1090px !important;
      }
      .modal-body {
        padding: 60px 230px 90px 90px;
      }
      .modal-content {
        border-radius: 15px !important;
      }
      .modal-body-sec1 {
        font-size: 52px !important;
        line-height: 78px !important;
      }
      .form-group {
        margin-top: 35px !important;
      }
      .input-label-form {
        font-size: 24px !important;
        line-height: 36px !important;
        margin-bottom: 28px !important;
      }
      .close {
        margin-right: 35px !important;
        margin-top: 40px !important;

        img {
          height: 30px !important;
          width: 30px !important;
          zoom: 1.2;
        }
      }

      .letsgo-btn {
        margin-top: 76px !important;
      }
      .form-input {
        font-size: 44px !important;
        padding-left: 30px;
        border-left: 2px solid rgba(183, 183, 183, 0.3) !important;
      }
      .form-input::placeholder {
        font-size: 44px !important;
      }

      .letsgo-button {
        width: 416px !important;
        height: 90px !important;
        font-size: 30px !important;
        border-radius: 41px !important;
      }
      .help-text {
        padding-top: 20px !important;
        //padding-right: 150px;
        line-height: 38px !important;
        font-size: 26px !important;
      }
    }
  }
}
</style>
